import RestricaoService from "@/services/RestricaoService";

export const restricao = {
  namespaced: true,
  state: {
    restricao: {},
  },
  actions: {
    getRestricao({ commit }, payload) {
      return RestricaoService.GetRestricao(payload).then(
        (restricao) => {
          return Promise.resolve(restricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRestricao({ commit }, payload) {
      return RestricaoService.PostRestricao(payload).then(
        (restricao) => {
          return Promise.resolve(restricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRestricao({ commit }, payload) {
      return RestricaoService.PutRestricao(payload).then(
        (restricao) => {
          return Promise.resolve(restricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRestricao({ commit }, payload) {
      return RestricaoService.DeleteRestricao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRestricaoOData({ commit }, payload) {
      return RestricaoService.GetRestricaoOData(payload).then(
        (restricao) => {
          return Promise.resolve(restricao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default restricao;
